import { HEALTH_REMINDERS_ENABLED } from "./features.js";
import type { NotificationKind } from "../types/notifications.js";

/**
 * The notification kinds that belong to the health reminders (medication
 * expiry and allergy-plan gaps), switched by HEALTH_REMINDERS_ENABLED.
 */
export const HEALTH_REMINDER_KINDS = [
  "medication_expiring",
  "allergy_plan_incomplete",
] as const satisfies readonly NotificationKind[];

/**
 * Kinds no surface shows right now. Shared by the server (the feed, unread
 * count, mark-read, read-all and the email queue all leave these out in their
 * repository WHERE clause) and the client (the settings page hides their
 * toggles), so the bell, the feed, the counts and the settings always agree.
 * Existing rows of these kinds stay in the database untouched; flipping the
 * switch back brings them back.
 */
export const HIDDEN_NOTIFICATION_KINDS: readonly NotificationKind[] = HEALTH_REMINDERS_ENABLED
  ? []
  : HEALTH_REMINDER_KINDS;

export function isNotificationKindVisible(kind: NotificationKind): boolean {
  return !HIDDEN_NOTIFICATION_KINDS.includes(kind);
}
